import { render, staticRenderFns } from "./ClubsItemListItem.vue?vue&type=template&id=1b6035f4"
import script from "./ClubsItemListItem.vue?vue&type=script&lang=js"
export * from "./ClubsItemListItem.vue?vue&type=script&lang=js"
import style0 from "./ClubsItemListItem.vue?vue&type=style&index=0&id=1b6035f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports